<pt-signature-input
  [formControl]="formControl"
  [label]="options | map: getLabel"
  [required]="options?.required"
  [class]="options?.htmlClass || ''"
/>
